<template>
    <div>
        <v-form ref="formDatosClases" lazy-validation>
            <ComunDialogComp v-model="estadoComp" fullscreen maxWidth="1200" @close-modal="CerrarModal"
                :title="tituloGeneral" :classCardText="'pt-0'">
                <template v-slot:body>
                    <mensajeSistema></mensajeSistema>
                    <v-stepper elevation="0" v-model="step">
                        <v-stepper-header style="display: none">
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content class="pa-0 pt-6" step="1">
                                <v-row>
                                    <v-col cols="12" sm="4" md="">
                                        <AutocompleteComp textLabel="Nivel:" v-model="filter.id_nivel" :dense="true"
                                            @change="cambiarNivel(filter.id_nivel)" :items="niveles" item-value="id"
                                            item-text="desc_nivel" :rules="validationRules.validateCampo" />
                                    </v-col>
                                    <v-col cols="12" sm="4" md="">
                                        <AutocompleteComp :dense="true" :isDisable="datosGrados.length == 0"
                                            textLabel="Grado:" v-model="filter.id_grado"
                                            @change="cambiarGrado(filter.id_grado)" :items="datosGrados" item-value="id"
                                            item-text="desc_grado" :rules="validationRules.validateCampo" />
                                    </v-col>

                                    <v-col cols="12" sm="4" md="">
                                        <AutocompleteComp :dense="true" :isDisable="datosSeccion.length == 0"
                                            textLabel="Sección:" v-model="filter.id_seccion" :items="datosSeccion"
                                            item-value="id" item-text="desc_seccion"
                                            :rules="validationRules.validateCampo" />
                                    </v-col>

                                    <v-col cols="12" sm="4" md="">
                                        <AutocompleteComp :dense="true" :isDisable="datosAreas.length == 0"
                                            textLabel="Área:" v-model="filter.id_area"
                                            @change="cambiarArea(filter.id_grado, filter.id_area)" :items="datosAreas"
                                            item-value="id" item-text="desc_area"
                                            :rules="validationRules.validateCampo" />
                                    </v-col>

                                    <v-col cols="12" sm="4" md="">
                                        <AutocompleteComp :dense="true" :isDisable="datosCursos.length == 0"
                                            textLabel="Curso:" v-model="filter.id_curso" @change="getEvaluacion(filter)"
                                            :items="datosCursos" item-value="id" item-text="desc_curso"
                                            :rules="validationRules.validateCampo" />
                                    </v-col>

                                    <v-col cols="12">
                                        <ComundataTablecomp :dense="true" :headers="ProgramarEvaluacionHeaders"
                                            :items="data" :search="search" whitSearch>

                                            <template v-slot:fecha="{ item }">
                                                {{ item.fecha || filtroFecha }}
                                            </template>

                                            <template v-slot:action_programar="{ item }">
                                                <div class="checkcolum">
                                                    <v-checkbox class="ma-0 pa-0" dense @click="addtem(item)"
                                                        v-model="filter.id_programacion" :value="item.id"></v-checkbox>
                                                </div>
                                            </template>

                                            <template v-slot:action_ver="{ item }">
                                                <TableButtonComp tooltipText="Visualizar clase" verButton
                                                    @click="visualizarClase(item)" />
                                            </template>
                                            <!-- v-if="componenteEvento.editar_submodulo" -->

                                            <template v-slot:action_editar="{ item }">
                                                <TableButtonComp @click="editItem(item)" editButton
                                                    tooltipText="Editar clase" />
                                            </template>
                                            <!-- v-if="componenteEvento.editar_submodulo" -->

                                            <template v-slot:action_borrar="{ item }">
                                                <!-- v-if="componenteEvento.borrar_submodulo" -->
                                                <TableButtonComp @click="deleteUsuario(item.id)" deleteButton
                                                    tooltipText="Borrar clase" />
                                            </template>
                                        </ComundataTablecomp>
                                    </v-col>

                                    <v-col class="text-end">
                                        <TableButtonComp normalButton @click="btnProgramarEval(filter)"
                                            textButton="Programar" iconBut="fas fa-plus" />
                                    </v-col>

                                </v-row>
                            </v-stepper-content>
                            <v-stepper-content class="pa-0" step="2">
                                <component :is="compName" :estadoWizard="estadoComponente" :parametros="parametroComp"
                                    :progDocData="data" @anterior="reloadComp" @close="CerrarModal" @hide-modal="hideModal()">
                                </component>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>

                    <v-row class="d-flex justify-center">
                        <v-col cols="9">
                            <v-btn class="animate__animated animate__pulse animate__infinite infinite mb-2" block text color="primary"
                                @click="openSesion = !openSesion"  v-show="displaySesion" >
                                <v-icon left> {{ openSesion ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}
                                </v-icon>
                                Temas que seran evaluados
                            </v-btn>
                        
                            <v-expand-transition>
                                <v-stepper v-model="stepper" v-show="openSesion" >
                                    <div v-for="tema of temaNames" :key="tema.id_programacion" v-show="openSesion" class="d-flex justify-center mt-1 py-1">
                                        {{ tema }}
                                    </div>
                                </v-stepper>
                            </v-expand-transition>
                        </v-col>
                 </v-row>

                </template>
            </ComunDialogComp>
        </v-form>

        <component :is="compVisor" :estadoComp="estadoModalConfig" @close="estadoModalConfig = false"
            :parametros="parametroConfigVisor">
        </component>

    </div>

</template>
<script>
import axios, { API_URL } from "@/helpers/axios"
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import visorContenido from '@/views/Manager/GestionContenido/viewGC/visorGestorContenido';
import { ProgramarEvaluacionHeaders } from '../../../../helpers/headersTable';
import { validationRules } from '../../../../helpers/validatorHelpers';
import WizardEvaluacion from '../components/WizardEvaluacion/wizardEvaluacion.vue'
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import TableButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';

export default {
    name: 'claseEvaluacionComp',
    components: {
        visorContenido,
        WizardEvaluacion,
        ComunDialogComp,
        TableButtonComp,
        AutocompleteComp,
        ComundataTablecomp
    },
    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
    },
    data: () => ({
        step: 1,
        datoLogin: sessionStorage,
        evento: null,
        ProgramarEvaluacionHeaders,
        selectedtems: [],
        niveles: [],
        datos: [],
        paramComponente: { "id_modulo": 8, 'id_submodulo': 96 },
        rutaServer: API_URL,
        data: [],
        filter: {},
        search: "",
        compName: "",
        estadoComponente: false,
        parametroComp: {},
        compVisor: "",
        estadoModalConfig: false,
        parametroConfigVisor: {},
        idProgComparar: [],
        temaNames:[],
        openSesion: false,
        displaySesion: false,
        stepper: 1,
    }),
    mounted() {
        this.loadMain();
    },
    computed: {
        ...mapGetters({
            componenteEvento: 'login/componenteEvento',
            periodoActual: 'globals/getPeriodosActual',
        }),
        ...mapState({
            datosDocente: state => state.globals.DocenteData,
            datosNiveles: state => state.globals.NivelesDocenteData,
            datosGrados: state => state.globals.GradosDocenteData,
            datosSeccion: state => state.globals.SeccionDocenteData,
            datosAreas: state => state.globals.AreasDocenteData,
            datosCursos: state => state.globals.CursosDocenteData,
            tituloGeneral: state => state.gestEvaluacion.tituloGeneral,
        }),
        validationRules() {
            return validationRules; // Importa y utiliza las reglas desde el archivo validatorHelpers.js
        },
    },
    watch: {
        estadoComp() {
            if (this.estadoComp) {
                this.loadMain()
            } else {
                this.limpiarForm()
            }
        },
    },
    methods: {
        ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
            setResetFiltros: "globals/setResetFiltros",
            mostrarLoading: "mostrarLoading",
            setlistaPreguntas: "gestEvaluacion/setlistaPreguntas",
            setTitle: "gestEvaluacion/setTitle"
        }),
        ...mapActions({
            parametroComponente: "login/parametroComponente",
            obtenerDocenteData: "globals/obtenerDocenteData",
            obtenerNivelesDocente: "globals/obtenerNivelesDocente",
            obtenerPeriodo: "globals/obtenerPeriodo",
            obtenerGradoDocente: "globals/obtenerGradoDocente",
            obtenerAreaDocente: "globals/obtenerAreaDocente",
            obtenerCursoDocente: "globals/obtenerCursoDocente",
            obtenerSeccionDocente: "globals/obtenerSeccionDocente",
            validateForm: "gestEvaluacion/validateForm",
        }),
        /**
         ________________________
        | MÉTODO CARGA INICIAL */
        async loadMain() {
            this.limpiarForm();
            this.openSesion = true;
            this.filter.id_docente = this.parametros.id_docente;

            if (this.parametros.evento == 'add') {
                this.niveles = this.parametros.niveles;
                this.setTitle(`Seleccionar clase a evaluar`);
            }

            if (this.parametros.evento == 'edit') {
                this.editItem(this.parametros.items);
                this.setTitle('Editar evaluación');
            }
        },
        /**
         ________________________
        | MÉTODO EDITAR LÓGICA */
        async editItem(items) {
            this.step = 2;
            this.compName = "WizardEvaluacion";
            this.estadoComponente = true;
            this.parametroComp = { items, evento: 'edit' }
        },
        /**
         _____________________________
        | MÉTODO OBTENER EVALUACION */
        async getEvaluacion(filter) {
            if (filter.id_seccion == "") {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe de seleccionar una sección`, tiempo: null })
                return false
            }
            try {
                let response = await axios.post(`/academico/progDocente/view/`, { filter })
                this.data = response.data

                if (this.data.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                }
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        /**
         ____________________________
        | MÉTODO SELECCIONAR NIVEL */
        async cambiarNivel(id_nivel) {
            await this.obtenerGradoDocente({
                id_colegio: this.datoLogin.id_colegio,
                id_docente: this.parametros.id_docente,
                id_nivel
            })
            await this.obtenerPeriodo({
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_nivel
            })
        },
        /**
         ____________________________
        | MÉTODO SELECCIONAR GRADO */
        async cambiarGrado(id_grado) {
            this.filter.id_area = '';
            this.data = [];
            await this.obtenerSeccionDocente({
                id_colegio: this.datoLogin.id_colegio,
                id_docente: this.parametros.id_docente,
                id_grado
            })
            await this.obtenerAreaDocente({
                id_colegio: this.datoLogin.id_colegio,
                id_docente: this.parametros.id_docente,
                id_grado
            });
        },
        /**
         ___________________________
        | MÉTODO SELECCIONAR AREA */
        async cambiarArea(id_grado, id_area) {
            this.filter.id_curso = ''
            this.data = []
            await this.obtenerCursoDocente({
                id_colegio: this.datoLogin.id_colegio,
                id_docente: this.parametros.id_docente,
                id_grado,
                id_area
            });
        },
        /**
         ____________________
        | MÉTODO VER CLASE */
        async visualizarClase(item) {
            try {
                this.compVisor = "visorContenido"
                this.estadoModalConfig = true
                this.parametroConfigVisor = {
                    id_clase: item.id_clase,
                    evento: "visualizar",
                    miniatura: false,
                    id_diapositiva: -1,
                    tipo_contenido: item.tipo_contenido == 1 ? "manager" : "colegio"
                }
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
            }
        },

        hideModal() {
            this.displaySesion = false;
            this.openSesion = false;
        },
        /**
         __________________________
        | MÉTODO PROGRAMAR CLASE */
        async btnProgramarEval(items) {
         
            this.setTitle('Programar evaluación');

            if (this.$refs.formDatosClases.validate() && items.id_programacion.length > 0) {


                    //-- Lógica que traera los temas y la clase --//
                this.displaySesion = true;
                // Obtiene los ids de todas las clases seleccionadas
                let selectedIds = this.filter.id_programacion;
            
                // Filtra los datos de las clases usando los ids seleccionados
                let filteredData = this.data.filter(e => selectedIds.includes(e.id));
            
                // Extrae los nombres de los temas de las clases seleccionadas
                this.temaNames = filteredData.map(e => `${e.nombre_tema}: ${e.nombre_clase}`);

                //---- FIN DE Lógica ----//


                const isIncluded = this.idProgComparar.every(element => items.id_programacion.includes(element));
                if (!isIncluded) {
                    this.setlistaPreguntas([]);
                }

                this.compName = "WizardEvaluacion"
                this.estadoComponente = true
                this.parametroComp = { items, evento: 'add', temas: this.selectedtems }

                this.step = 2

            } else {
                this.setEnviarMens({ tipo: "W", mensaje: "Debe seleccionar un campo para programar una evaluación.", tiempo: 5000 })
            }

        },

        addtem(item) {
            const index = this.selectedtems.indexOf(item);
            if (index === -1) {
                this.selectedtems.push(item);
            } else {
                this.selectedtems.splice(index, 1);
            }
        },
        /**
         _________________________
        | MÉTODO LIMPIAR CAMPOS */
        limpiarForm() {
            this.openSesion = false;
            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_periodo: '',
                id_nivel: '',
                id_grado: '',
                id_seccion: '',
                id_area: '',
                id_curso: '',
                id_docente: '',
                id_programacion: [],
                id_estado: 4   // ck1_acd_prog_docentes_estados  (4: Ejecutada)
            }
            this.data = []
            this.resetValidation()

        },
        /**
         ___________________________
        | MÉTODO RESTABLECER FORM */
        resetValidation() {
            this.$refs.formDatosClases.resetValidation()
        },
        /**
         _______________________________
        | MÉTODO REFRESCAR COMPONENTE */
        reloadComp(item) {
            this.setTitle(`Seleccionar clase a evaluar`);
            this.displaySesion = false;
            this.idProgComparar = item
            this.step = 1;
            this.estadoComponente = false
        },
        /**
         _______________________
        | MÉTODO CERRAR MODAL */
        CerrarModal() {
            this.step = 1;
            this.estadoComponente = false
            this.$emit('close')
        }
    },
}
</script>
<style scoped>
.checkcolum {
    display: flex;
    justify-content: center;
    margin-bottom: -20px;
}
</style>